import { DeepPartial, LocaleConfig } from '@empathybroker/ebx-gluon';
import * as messages from './messages';

export const DESKTOP_LOCALE_CONFIG: DeepPartial<LocaleConfig> = {
  messages
};
